import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const categoryAPI = {
  add: async (info) => axios.post(`${baseURL}/category`, info).then((res) => res.data),
  all: async () => axios.get(`${baseURL}/category`).then((res) => res.data),
  single: async (idToSearch) => axios.get(`${baseURL}/category/${idToSearch}`).then((res) => res.data),
  update: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/category/${id}`, details).then((res) => res.data);
  },
  delete: async (idToSearch) => axios.delete(`${baseURL}/category/${idToSearch}`).then((res) => res.data)
};
